<template>
  <div class="status">
    <div class="current-status">
      <p v-if="!isLoading">
        {{emoji}} {{text}}
      </p>
      <p v-if="isLoading">&nbsp;</p>
      <SvgLoading v-if="isLoading" size="50"></SvgLoading>
    </div>

    <hr>

    <div class="update-status">
      <button v-on:click="write"
              :disabled="isLoading"
              class="btn-write btn-reset"
              data-value="reset"
      ></button>
      <button v-on:click="write"
              v-long-press="onLongpress"
              :disabled="isLoading"
              class="btn-write btn-meeting"
              data-value="meeting"
      ></button>
      <button v-on:click="write"
              v-long-press="onLongpress"
              :disabled="isLoading"
              class="btn-write btn-home"
              data-value="home"
      ></button>
      <button v-on:click="write"
              v-long-press="onLongpress"
              :disabled="isLoading"
              class="btn-write btn-sick"
              data-value="sick"
      ></button>
      <button v-on:click="write"
              v-long-press="onLongpress"
              :disabled="isLoading"
              class="btn-write btn-vacationing"
              data-value="vacationing"
      ></button>
      <button v-on:click="write"
              v-long-press="onLongpress"
              :disabled="isLoading"
              class="btn-write btn-lunch"
              data-value="lunch"
      ></button>
      <p v-if="error" class="error">Error while writing status</p>
    </div>

    <div v-if="showResetTimer"
         class="reset-timer"
    >
      <p>reset status in</p>
      <label>
        <input type="number"
               v-model="resetTimer"
               class="reset-timer__input"
               min="1"
               step="1"
               name="resetTimer"
        >
      </label>
      <p>minutes</p>
      <button v-on:click="submitResetTimer"
              class="reset-timer__submit">set
      </button>
      <button v-on:click="cancelResetTimer"
              class="reset-timer__cancel"
      >cancel
      </button>
    </div>
  </div>
</template>

<script>
import SvgLoading from '@/assets/SvgLoading';
import {
  getStatus,
  writeStatus,
} from '@/data';
import {
  isCordova,
} from '@/utils';

export default {
  name: 'Status',

  components: {
    SvgLoading,
  },

  created() {
    this.getStatus();

    if (window.walter == null) {
      console.error('walter plugin not defined');
    }
  },

  data() {
    return {
      error: false,
      isLoading: true,

      showResetTimer: false,
      resetTimer: 60,

      emoji: null,
      text: null,
    };
  },
  methods: {
    getStatus() {
      getStatus()
        .then((status) => {
          this.isLoading = false;
          this.emoji = status.emoji;
          this.text = status.text;
        })
        .catch((error) => {
          this.error = true;
          this.isLoading = false;
          console.error(error);
        });
    },
    write(event) {
      const status = {
        emoji: null,
        text: null,
      };
      switch (event.target.dataset.value) {
        case 'meeting':
          status.emoji = ':spiral_calendar_pad:';
          status.text = 'In a meeting';
          break;
        case 'home':
          status.emoji = ':house:';
          status.text = 'It\'s home time!';
          break;
        case 'sick':
          status.emoji = ':face_with_thermometer:';
          status.text = 'Out sick';
          break;
        case 'vacationing':
          status.emoji = ':palm_tree:';
          status.text = 'Vacationing';
          break;
        case 'lunch':
          status.emoji = ':hamburger:';
          status.text = 'At lunch';
          break;
        default:
          break;
      }

      this.error = false;
      this.isLoading = true;
      writeStatus(status)
        .then(() => this.getStatus())
        .catch((error) => {
          this.error = true;
          this.isLoading = false;
          console.error(error);
        });

      if (status.emoji === null && isCordova) {
        walter.clearResetTimer((message) => {
          if (message !== 'success') {
            console.error('unable to clear resetTimer', message);
          }
        }, (error) => {
          console.error('unable to clear resetTimer', error);
        });
      }
    },
    onLongpress(event) {
      this.write(event);
      if (!isCordova) {
        return;
      }
      this.resetTimer = 60;
      this.showResetTimer = true;
    },
    submitResetTimer() {
      this.showResetTimer = false;
      walter.setResetTimer(this.resetTimer, (message) => {
        if (message !== 'success') {
          console.error('unable to set resetTimer', message);
        }
      }, (error) => {
        console.error('unable to set resetTimer', error);
      });
    },
    cancelResetTimer() {
      this.showResetTimer = false;
    },
  },
};
</script>

<style scoped>
.status {
  position: relative;
  text-align: center;
}

.current-status,
.update-status {
  position: relative;
  margin: 30px;
}

.btn-write {
  width: 70px;
  height: 70px;
  padding: 15px;
  margin: 10px;

  border: none;
  border-radius: 10px;
  background-color: #eee;
  background-size: contain;
}

.btn-reset {
  border-radius: 10px;
  background-color: #eee;
}

.btn-meeting {
  background-image: url('~@/assets/emoji_meeting.png');
}

.btn-home {
  background-image: url('~@/assets/emoji_home.png');
}

.btn-sick {
  background-image: url('~@/assets/emoji_sick.png');
}

.btn-vacationing {
  background-image: url('~@/assets/emoji_vacationing.png');
}

.btn-lunch {
  background-image: url('~@/assets/emoji_lunch.png');
}

.error {
  color: red;
}

.reset-timer {
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: white;
}

.reset-timer__input {
  width: 80px;
  padding: 4px 6px;
  font-size: 30px;
  text-align: right;
}

.reset-timer__submit {
  margin-bottom: 20px;
  padding: 6px 32px;
  font-size: 30px;
  background: lightgreen;
}

.reset-timer__cancel {
  padding: 4px 6px;
  background: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Status.vue